module.exports = __webpack_public_path__ + "static/img/cinema-16.c0c25c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img/cinema-16.png
// module id = 1383
// module chunks = 4